import React from "react";
import SelfClearingNumericTextBox from "../SelfClearingNumericTextBox/SelfClearingNumericTextBox";
import "./DataGridPerecentInputCell.scss";
import { isFieldLocked } from "../../../Utilities/shared";

const DataGridPercentInputCell = (props) => {
  const onChange = (e) => {
    props.onChange({
      dataItem: props.dataItem,
      field: props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value,
    });
  };

  const { dataItem, field } = props;
  const dataValue = dataItem[field] === null ? "" : dataItem[field];
  const cellClass = dataItem.inEdit ? "edit-mode" : "read-mode";

  const isValid = dataItem.invalidFields
    ? !dataItem.invalidFields.includes(field)
    : true;

  const showEditMode = dataItem.inEdit && !isFieldLocked(dataItem, field);

  return (
    <td className={`instream-datagrid-percent-cell ${cellClass}`}>
      {showEditMode && (
        <SelfClearingNumericTextBox
          label={""}
          disabled={!dataItem.inEdit}
          hideArrows={true}
          value={dataValue}
          min={0}
          max={1}
          step={0.01}
          format="0.00%"
          update={onChange}
          valid={dataValue >= 0 && dataValue <= 1 && isValid}
        />
      )}
      {!showEditMode && (
        <React.Fragment>{(dataValue * 100).toFixed(2)}%</React.Fragment>
      )}
    </td>
  );
};

export default DataGridPercentInputCell;
